(function () {

  angular
    .module('meanApp')
    .directive('mobilenav', mobilenav);

  function mobilenav () {
    return {
      restrict: 'EA',
      templateUrl: '/common/directives/mobileNav/mobile.nav.template.html',
      replace: true,
      controller: 'mobileNavCtrl as vm'
    };
  }

})();